// Hook pour mettre à jour automatiquement le titre de la page selon la route
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const TITLES = {
  '/': 'Accueil',
  '/comptes': 'Nos comptes',
  '/cartes': 'Cartes bancaires',
  '/credits': 'Crédits',
  '/assurances': 'Assurances',
  '/bourse': 'Bourse',
  '/aide': 'Aide & Support',
  '/a-propos': 'À propos',
  '/professionnels': 'Espace Professionnels',
  '/inscription': 'Ouvrir un compte',
  '/connexion': 'Connexion',
  '/activation': 'Activation de votre compte',
  '/verification-otp': 'Vérification d\'identité',
  '/mot-de-passe-oublie': 'Mot de passe oublié',
  '/mentions-legales': 'Mentions légales',
  '/cgu': 'Conditions générales',
  '/confidentialite': 'Politique de confidentialité',
  '/cookies': 'Gestion des cookies',
  '/rgpd': 'RGPD',
  '/plan-du-site': 'Plan du site',
};

const DASHBOARD_TITLES = {
  '/dashboard/carte': 'Mes cartes',
  '/dashboard/virement': 'Virements',
  '/dashboard/rib': 'Mon RIB',
  '/dashboard/transactions': 'Transactions',
  '/dashboard/profil': 'Mon profil',
  '/dashboard': 'Espace Client',
  '/admin': 'Espace Admin',
};

export function getTitleForPath(pathname) {
  if (TITLES[pathname]) return TITLES[pathname];
  for (const prefix of Object.keys(DASHBOARD_TITLES)) {
    if (pathname.startsWith(prefix)) return DASHBOARD_TITLES[prefix];
  }
  return null;
}

export default function PageTitle() {
  const location = useLocation();

  useEffect(() => {
    const sectionTitle = getTitleForPath(location.pathname);
    document.title = sectionTitle
      ? `BFI Groupe — ${sectionTitle}`
      : 'BFI Groupe — Banque en ligne';
  }, [location.pathname]);

  return null;
}
